import React from 'react'
import { Loading, Message } from '@workwhile/ui'
import { parseErrorMessage } from 'api'
import { UserPayment, hasHighnoteTransfer } from 'api/payments/getUserPayments'
import { usePayoutSummary } from 'queries/payments/usePayoutSummary'
import { HighnotePaymentDetails } from './HighnotePaymentDetails'

type UserPaymentExpandedContentProps = {
  payment: UserPayment
}

export const UserPaymentExpandedContent = ({
  payment,
}: UserPaymentExpandedContentProps) => {
  const {
    data: payoutSummary,
    isLoading,
    isError,
    error,
  } = usePayoutSummary(hasHighnoteTransfer(payment) ? payment.id : null)

  if (!hasHighnoteTransfer(payment)) {
    return null
  }

  if (isLoading) {
    return <Loading />
  }

  if (isError || !payoutSummary?.highnote) {
    return (
      <Message variant="error">
        {parseErrorMessage(error) ??
          'Failed to load Highnote transfer details.'}
      </Message>
    )
  }

  return (
    <HighnotePaymentDetails
      userTimezone={payment.userTimezone}
      highnote={payoutSummary.highnote}
    />
  )
}
